export default __webpack_public_path__ + "static/media/margins_relationship.34305fdb.csv";